import { isCollectEnabledForV3, isCollectModuleEnabled, } from '@office-start/ai-hub-config-service';
/* Collect AI Hub module can be enabled for office.com/v2  */
export var collectRouteGuard = function (props) {
    var isEnabled = isCollectModuleEnabled(props.featureGates, props.userEntitlements, props.adminPolicy);
    var canActivate = !!(isEnabled &&
        (!props.isAIHubEnabled || isCollectEnabledForV3(props.featureGates)));
    return { canActivate: canActivate };
};
//# sourceMappingURL=collectRouteGuard.js.map